import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
// 修改信息
export default async function constomUpUser(context: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/member/update', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  return res;
}
